import { productStore } from './store';
import { type FnReducer } from './types';

type ImportFromExcelState = {
    status: 'file_empty' | 'new';
    fileErrorMessage?: string;
    isUnsupportedTemplate: boolean;
};

const initialState: ImportFromExcelState = {
    status: 'file_empty',
    isUnsupportedTemplate: false,
};

const init: FnReducer<ImportFromExcelState> = (state) => {
    state.status = initialState.status;
    state.fileErrorMessage = initialState.fileErrorMessage;
    state.isUnsupportedTemplate = initialState.isUnsupportedTemplate;
};

const setFile: FnReducer<ImportFromExcelState> = (state) => {
    state.status = 'new';
    state.fileErrorMessage = undefined;
    state.isUnsupportedTemplate = false;
};

const checked: FnReducer<ImportFromExcelState, undefined> = (state) => {
    state.fileErrorMessage = undefined;
    state.isUnsupportedTemplate = false;
};

const notChecked: FnReducer<ImportFromExcelState, { fileErrorMessage?: string; isUnsupportedTemplate?: boolean }> = (
    state,
    { payload }
) => {
    state.fileErrorMessage = payload.fileErrorMessage;
    state.isUnsupportedTemplate = payload.isUnsupportedTemplate ?? false;
};

const clearFile: FnReducer<ImportFromExcelState> = (state) => {
    state.status = 'file_empty';
    state.fileErrorMessage = undefined;
};

const importFromExcelSlice = productStore.createSlice({
    name: 'importFromExcel',
    initialState,
    reducers: { setFile, checked, clearFile, notChecked, init },
});

export const {
    init: initImportProductsFromExcel,
    setFile: setFileImportProductsFromExcel,
    clearFile: clearFileImportProductsFromExcel,
    notChecked: notCheckedImportProductsFromExcel,
} = importFromExcelSlice;

export const [useImportProductsFromExcel] = importFromExcelSlice.createSelector((state) => {
    return {
        status: state.status,
        fileErrorMessage: state.fileErrorMessage,
        isUnsupportedTemplate: state.isUnsupportedTemplate,
    };
});
